<template>
  <div class="about-page">
    <main class="about-main">
      <div class="about-container">
        <div class="about-logo">
          <img :src="logoImg" alt="ChaCha" class="about-logo-img" />
        </div>

        <section class="about-section">
          <h2>About ChaCha:</h2>
          <p>ChaCha is a free voice chat application! Whether you're creating chat rooms or chatting with friends in voice groups, everything is free. Sounds exciting? Let's find out!</p>
        </section>

        <section class="about-section">
          <h2>Main Functions:</h2>
          <ul>
            <li>Live chat with friends either local  directly in a chat room.</li>
            <li>Free text message, high quality voice and video chat with your friends.</li>
            <li>It offers a wide variety of virtual gifts, which you can send to your friends.</li>
            <li>The more people watching, the more fantastic the atmosphere will be. Join a group room, start an online party with friends, make new friends, and have fun by expanding your social circle.</li>
          </ul>
        </section>
        <section class="about-section">
          <p>Your happiness is our goal. Feel free to give us any feedback. We are happy to hear your complaints and advice: <a href="mailto:contact@chachaapp.net">contact@chachaapp.net</a>.</p>
        </section>
      </div>

    </main>
  </div>
</template>

<script>
import logoImg from '../../common/imgs/favicon.png'

export default {
  data() {
    return {
      logoImg
    }
  }
}
</script>
